import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/ingresos/ingresosVer';
import IngresosFormVer from './IngresosFormVer';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_ingresos_ver,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p,)(IngresosFormVer);
